export default
{
  message: 'hello i18n !!',
  app: {
    about: 'Scopri E-cademy',
    register: 'Registrati',
  },
  home: {
    title: 'Benvenuto in E-cademy Music',
    contacts: 'Contatti',
  },
  menu: {
    teachers: 'Insegnanti',
    courses: 'Corsi',
    'musical-instruments': 'Strumenti Musicali',
  },
  header: {
    login: 'Accedi',
    profile: 'Il mio profilo',
    messages: 'Messaggi',
    logout: 'Esci',
    menu: 'Menu',
  },
  login: {
    title: 'Hai già un account? Log in!',
    'title-register': 'Nuovo su E-cademy?',
    reset: 'Password dimenticata?',
  },
  register: {
    title: 'Nuovo su E-cademy? Registrati ora!',
    subtitle: 'Registrati come studente',
    first: 'Nome',
    last: 'Cognome',
    confirm: 'Conferma Password',
    register: 'Registrati',
    lang: 'Lingua',
    login: 'Possiedi già un account? Effettua il',
    masterclass: 'Registrati per far parte anche tu del mondo di E-cademy!',
    'register-me': 'Registrami ora!',
    verify: 'Controlla la tua casella di posta e verifica la tua email!',
    asTeacher: 'Per essere registrato come insegnante scrivere a: ',
  },
  errors: {
    firstname: 'Inserire il nome',
    lastname: 'Inserire il cognome',
    email: 'Inserire un indirizzo email valido',
    password: 'Inserire una password',
    confirm: 'Inserire la conferma della password',
    subject: "Inserire l'oggetto",
    message: 'Inserire il corpo del messaggio',
  },
  dashboard: {
    contact: 'Contatta',
    book: 'Prenota lezione',
    calendar: 'Calendario lezioni',
    complete: 'Completa il tuo profilo',
    teachers: 'I nostri insegnanti',
    'profile-photo': 'Carica foto profilo',
  },
  admin: {
    title: "Sono la dashboard dell'ADMIN: ",
    subtitle: 'Registra un nuovo insegnante',
  },
  teacher: {
    experience: 'Esperienza',
    lessons: 'Lezioni tenute',
    students: 'Studenti seguiti',
    reviews: 'Recensioni ottenute',
    noReviews: 'Ancora nessuna recensione',
    settings: 'Impostazioni',
    classrooms: 'Lezioni',
    jobs: 'Esperienze lavorative',
    studies: 'Studi',
    instruments: 'Strumenti',
    review: 'Recensioni',
    yourReviews: 'Le tue recensioni',
    info: 'Info',
    calendar: 'Calendario',
    tiers: 'Lezioni',
    masterclasses: 'Masterclasses',
    payments: 'Pagamenti',
  },
  student: {
    progress: 'Progressi',
    lessons: 'Lezioni seguite',
    teachers: 'Insegnanti seguiti',
    data: 'Anagrafica',
    age: 'Età:',
    residence: 'Residenza:',
    payments: 'I tuoi metodi di pagamento',
    studies: 'Studi',
    instruments: 'Strumenti',
  },
  messageForm: {
    from: 'da:',
    to: 'a:',
    subject: 'oggetto:',
    message: 'messaggio:',
    send: 'Invia',
    please: 'Effettuare il log in per inviare un messaggio',
    sent: 'Messaggio inviato',
  },
  timezone: {
    title: 'In quale fuso orario di riferimento vuoi visualizzare i calendari e le date?',
    save: 'Salva',
    change: 'Cambia',
    undo: 'Annulla',
    local: 'Il tuo fuso orario locale:',
    default: 'Il tuo fuso orario di riferimento:',
    useLocal: 'Usa timezone locale',
    area: 'Scegli area geografica',
    country: 'Scegli la città di riferimento',
    seeLessons: "Vedi lezioni nel fuso orario dell'insegnante",
    comeBack: 'Torna al tuo fuso orario',
    timezone: 'Fuso orario',
    success: 'Fuso orario aggiornato con successo',
    errorSelect: 'Selezionare un fuso orario',
  },
  languageSwitcher: {
    label: 'lingua:',
  },
  newTimezone: {
    title: 'Stai accedendo da una zona con un fuso orario diverso da quello che hai impostato',
    question: 'Quale vuoi utilizzare?',
    save: 'Conferma',
  },
  lessonsPrices: {
    title: 'I prezzi delle tue lezioni',
    title_visitors: 'Prezzi lezioni',
    subtitle: 'Potrai modificarli in seguito dal tuo profilo',
    currency: 'Valuta:',
    single: 'Lezione singola:',
    extra: 'Lezione singola con extra (appunti e spartiti):',
    package: 'Pacchetto di 10 lezioni:',
    required: 'campi obbligatori',
    save: 'Salva',
  },
  slotsCreation: {
    title: 'INSERISCI I TUOI ORARI DI LEZIONE',
    days: 'GIORNO/I',
    from: 'da:',
    to: 'a:',
    lessonTime: 'Durata singola lezione:',
    breakTime: 'Pausa tra lezioni consecutive:',
    minutes: 'minuti',
    startHour: 'Ora inizio',
    endHour: 'Ora fine',
    startLunch: 'Ora inizio prima pausa',
    endLunch: 'Ora fine prima pausa',
    startDinner: 'Ora inizio seconda pausa',
    endDinner: 'Ora fine seconda pausa',
    secondBreak: 'Aggiungi una seconda pausa',
    save: 'Salva',
    message: 'Nuovi slot di lezione salvati',
    button: 'Inserisci nuove lezioni',
    calendarTitle: 'Calendario',
    noLessons: 'Non hai ancora inserito nessuna lezione',
    back: 'Indietro',
    lunch: 'PAUSA',
    warning: 'Attenzione! Alcuni degli slot richiesti non verranno inseriti perché in sovrapposizione ad altri già esistenti.',
  },
  bookedLessonsDashboard: {
    title: 'Prossime lezioni prenotate: ',
    title2: 'Prossime lezioni prenotate come STUDENTE: ',
    with: 'con',
    see: 'Vedi tutte',
    reduce: 'Riduci',
    startLesson: 'INIZIA LA LEZIONE!',
  },
  bookingSlots: {
    title: 'Prenota questa lezione',
    subtitle: 'Stai prenotando una lezione il',
    from: 'dalle:',
    to: 'alle:',
    cancel: 'Annulla',
    book: 'Prenota la lezione',
    sorry: 'Alcuni slot sono stati prenotati da altri utenti.',
    please: 'Si prega di aggiornare la pagina.',
    noLessons: 'Non sono presenti prossime lezioni',
    booked: 'Lezione prenotata con successo!',
    notify: 'Notifica ',
    lang: "Scegli la lingua per la lezione tra quelle offerte dall'insegnante:",
    pack: 'Pacchetto di',
    lessons: 'lezioni',
    'lesson-tier': 'Scegli il tipo di lezione',
    default: 'Usa il metodo di pagamento di default',
    'single-lesson': 'Lezione singola',
    pending: 'Slot in sospeso',
    student: 'Lo studente',
    notComplete: "ha iniziato la prenotazione della lezione ma non l'ha ancora completata.",
    free: 'Libera lo slot',
    cancellationDeadline: 'I termini di cancellazione gratuita per questo insegnante sono entro ',
    hoursFromLesson: " ore dall'inizio della lezione.",
    warning: 'Attenzione! Questa lezione inizia tra meno di ',
    noFreeCancellation: ' ore, quindi non sarà possibile cancellare gratuitamente la lezione e il pagamento verrà addebitato.',
    uncompleted: 'Non hai completato la prenotazione della lezione!',
    complete: 'Completa prenotazione',
    inAnHour: "Se la prenotazione non verrà completata entro un'ora, lo slot verrà liberato",
    cannotBook: "Non è possibile prenotare questa lezione perché l'insegnante non ha ancora compilato le impostazioni delle sue lezioni.",
    comments: "Scrivi le tue esigenze/richieste all'insegnante (facoltativo):",
  },
  editingSlots: {
    yourLesson: 'La tua lezione',
    delete: 'Elimina lezione',
    edit: 'Modifica lezione',
    save: 'Salva',
    areYouSure: 'Sei sicuro di voler eliminare la lezione?',
    success: 'Lezione aggiornata con successo',
    warning: "Attenzione! Si sta spostando la lezione in contemporanea ad un'altra",
    new: 'Seleziona una nuova lezione tra quelle disponibili',
    customize: 'O personalizza',
  },
  review: {
    title: 'Lascia una recensione della lezione appena conclusa',
    aboutTeacher: "A proposito dell'insegnante",
    lessonTime: "L'insegnante rispetta gli orari di lezione.",
    clarifications: "L'insegnante è disposto a fornire chiarimenti e spiegazioni.",
    interaction: "L'insegnante interagisce efficacemente stimolando interesse verso la lezione.",
    explanation: "L'insegnante espone gli argomenti in modo chiaro.",
    aboutPlatform: 'A proposito della piattaforma',
    platformAdapted: 'La piattaforma è stata adatta allo svoglimento della lezione.',
    audioVideo: 'La qualità audio-video era adeguata.',
    comments: 'Commenti e suggerimenti:',
    save: 'Salva',
    savedReview: 'Recensione salvata con successo',
    pleaseVoteTeacher: 'Per favore, dai un voto al tuo insegnante',
    pleaseVotePlatform: 'Per favore, dai un voto alla piattaforma',
  },
  notifications: {
    login: 'Login effettuato con successo!',
    logout: 'Non sei più loggato!',
    credentialsInvalid: 'Le credenziali inserite non sono valide.',
    errorTryAgain: 'Si è verificato un errore. Si prega di riprovare',
    expiredSession: "Sessione scaduta. Effettuare l'accesso",
    errorReload: 'Si è verificato un errore. Si prega di ricaricare la pagina',
    errorPayment: 'Si è verificato un errore nel pagamento, si prega di riprovare',
    voteTeacher: "Per favore, dai un voto all'insegnante",
    votePlatoform: 'Per favore, dai un voto alla piattaforma',
    overlapDate: 'La data inserita si sovrappone a uno slot esistente',
    changedLessonSent: 'Proposta di cambio lezione inviata',
    answerSentToTeacher: "La tua risposta è stata inviata all'insegnante",
    none: 'Qui potrai vedere le tue notifiche.',
  },
  payments: {
    stripe: 'Carta di credito',
    paypal: 'Paypal',
    sepa: 'SEPA',
    save: 'Salva come pagamento predefinito',
    title: 'Pagamento',
    choose: 'Scegli il metodo di pagamento da utilizzare:',
    default: 'Il tuo metodo di pagamento predefinito è:',
    change: 'Cambia',
    next: 'Prosegui',
    auth: 'Autorizza pagamento',
    title2: "In questa fase viene salvata solo l'autorizzazione al pagamento, il prelievo verrà effettuato nel momento in cui scadranno i termini di cancellazione gratuita.",
    title3: "(Nel caso in cui al momento del pagamento l'autorizzazione fosse scaduta, potrebbe essere richiesta nuovamente).",
    'booking-summary-lesson': 'Stai prenotando una lezione il giorno',
    'booking-summary-price': 'al prezzo di',
    success: 'Metodo di pagamento aggiornato con successo',
    authorized: 'Pagamento autorizzato',
    received: 'Pagamento ricevuto',
    gain: 'Guadagno del mese',
    receiveds: 'Pagamenti ricevuti',
    noReceived: 'Non hai ancora ricevuto nessun pagamento.',
    lessons: 'I pagamenti delle tue lezioni',
    noLessons: 'Non hai ancora completato nessuna lezione.',
    authFailed: 'La tua autorizzazione al pagamento è fallita!',
    update: 'Aggiorna il metodo di pagamento',
    failed: 'Non riusciamo a procedere con il metodo di pagamento che hai inserito',
    updateLesson: 'Aggiorna il metodo di pagamento per questa lezione',
  },
  stripe: {
    data: 'Dati pagamento',
    holder: 'Intestatario carta',
    save: 'Salva',
    add: 'Aggiungi una carta',
    enterPaymentMethod: 'Inserire un metodo di pagamento valido',
    authRequired: 'Necessaria autenticazione per autorizzare il pagamento',
    expiry: 'Scadenza:',
  },
  cards: {
    cards: 'Le mie carte',
    areYouSure: 'Sei sicuro di voler eliminare questo metodo di pagamento?',
    irreversible: 'Operazione irreversibile',
    delete: 'Elimina',
    cancel: 'Annulla',
    expired: 'SCADUTA!',
    last: 'ultimo metodo di pagamento utilizzato',
    seeAll: 'Vedi tutte le carte',
    close: 'Chiudi',
  },
  sepa: {
    firstname: 'Nome',
    lastname: 'Cognome',
    save: 'Salva IBAN',
  },
  iban: {
    seeAll: 'Vedi tutti gli iban',
    close: 'Chiudi',
    add: 'Aggiungi un iban',
    save: 'Salva iban',
  },
  masterclass: {
    price: 'Prezzo della registrazione',
    places: 'Posti disponibili',
    participate: 'Partecipa',
    registered: 'Iscritti:',
    'no-slides': 'Nessuna slide caricata.',
    'load-slides': 'Carica slide',
    'change-slides': 'Cambia slide',
    start: 'Avvia la masterclass!',
    'is-started': 'La masterclass è iniziata!',
    'subscribed-m': 'masterclass seguite',
    'no-masterclass': ' Non sei ancora iscritto a nessuna masterclass!',
    started: 'Per iniziare scopri le',
    seeMore: 'Scopri di più',
    from: 'dalle',
    to: 'alle',
    registerNow: 'Registrati subito per partecipare!',
    only: 'Solo',
    placesStill: 'posti ancora disponibili!',
    subscribe: 'Iscriviti!',
    alreadySubscribed: 'Sei iscritto/a alla masterclass',
    withdraw: "Ritira l'iscrizione",
    open: 'Apri',
    title: 'E-cademy Masterclasses',
    unlimited: 'Posti illimitati',
    add: 'Aggiungi una nuova masterclass',
    addTitle: 'Titolo',
    description: 'Descrizione',
    day: 'Giorno',
    max: 'Massimo numero di partecipanti',
    success: 'Masterclass salvata con successo',
    enrolling: 'Ti stai iscrivendo alla masterclass di',
    on: 'il giorno',
    privacy: 'Acconsento al trattamento dei miei dati e dichiaro di aver letto la privacy policy',
    newsletter: " Acconsento all'iscrizione alla newsletter",
    signme: 'Registrami!',
    successRegister: 'Registrazione avvenuta con successo!',
    checkMail: 'Controlla la tua casella di posta',
    pleaseAcceptPrivacy: 'Si prega di accettare la privacy policy.',
    pleaseComplete: 'Si prega di completare i dati richiesti.',
    registerMe: 'Registrami ora!',
    edit: 'Modifica',
    free: 'Gratis',
    unlimit: 'Illimitati',
    program: 'Programma',
  },
  messages: {
    received: 'Ricevuti',
    sent: 'Inviati',
    message: 'Messaggi',
    'none-sent': 'Non hai inviato nessun messaggio.',
    'none-received': 'Non hai ricevuto nessun messaggio.',
    answer: 'Rispondi',
    read: 'Segna come letto',
    unread: 'Segna come da leggere',
    forward: 'Inoltra',
  },
  lesson: {
    classrooms: 'Le tue Classi',
    classroom: 'La tue Classe',
    'no-class': "Non sei ancora all'interno di nessuna classe!",
    discover: 'Per iniziare scopri i nostri',
    teachers: 'insegnanti',
    start: 'di Academy e prenota una lezione!',
    with: 'Lezioni con',
    next: 'Prossima lezione',
    download: 'Scarica tutti i media',
    back: 'Torna alle tue lezioni',
    booked: 'Lezioni Prenotate',
    past: 'Lezioni Passate',
    teacher: 'Insegnante',
    payment: 'Pagamento ricevuto',
    'payment-pending': 'Pagamento in attesa',
    'payment-method': 'Metodo di pagamento:',
    'change-payment': 'Cambia metodo di pagamento',
    'start-lesson': 'Inizia la lezione!',
    'review-score': 'Il tuo punteggio:',
    review: 'Lascia una recensione!',
    lang: 'Lingua',
    participant: 'Partecipante',
    original: 'Orario originale',
    newProposed: 'Nuovo orario proposto',
    newAsked: 'Nuovo orario che hai proposto',
    reject: 'Rifiuta nuovo orario',
    accept: 'Accetta nuovo orario',
    lessonWith: 'Lezione con',
    goClassrooms: 'Vai alle classi',
    needChange: 'Hai bisogno di spostare la lezione?',
    contact: 'Contatta',
    startLesson: 'Inizia la lezione!',
    reviewScore: 'Punteggio recensione studente',
    noReviews: 'Nessuna recensione',
    success: 'Lezione prenotata con successo',
    comments: 'Messaggio dallo studente:',
    yourComments: 'Il tuo messaggio:',
    areYouSure: 'Sei sicuro di voler cancellare questa lezione?',
    irreversible: 'Operazione irreversibile',
    terms: 'Essendo scaduti i termini di cancellazione gratuita, il pagamento verrà effettuato.',
    cancelLesson: 'Cancella lezione',
    freeCancelLesson: 'Cancella lezione gratuitamente',
    cancel: 'Annulla',
    canceled: 'Cancellata',
    cancelMessage: "Lascia un messaggio all'insegnante per fargli sapere il motivo:",
    cancelSuccess: 'Lezione cancellata con successo',
  },
  skills: {
    complete: 'Informazioni aggiuntive',
    years: 'Anni',
    year: 'Anno di diploma / laurea',
    'attended-year': 'Anno di diploma / laurea',
    'attendance-years': 'Anni di pratica',
    'teaching-years': 'Anni di insegnamento',
    course: 'Corso',
    qualifications: 'Qualifiche',
    'personal-information': 'Informazioni personali',
    studies: 'Studi',
    'school-name': 'Nome scuola',
    city: 'Città',
    province: 'Provincia',
    'course-attended': 'Corso frequentato',
    title: 'Qualifica ottenuta',
    add: 'Aggiungi scuola / corso',
    save: 'Salva scuola',
    'add-school': 'Aggiungi scuola',
    'new-school': 'Scusa! Non conosciamo la tua scuola, vuoi aggiungerla?',
    instruments: 'Strumenti musicali',
    instrument: 'Come descriveresti la tua relazione con questo strumento?',
    'practise-years': 'Anni di pratica',
    why: 'Cosa ti piacerebbe imparare?',
    for: '(per aiutare gli insegnanti a capire la tua motivazione e il tuo livello)',
    'add-instrument': 'Aggiungi strumento',
    'new-instrument': ' Scusa! Questo strumento non è in elenco, vuoi aggiungerlo?',
    'instr-name': 'Nome strumento',
    nation: 'Nazione',
    teach: 'Strumenti da insegnare',
    'teach-method': 'Come descriveresti il tuo metodo di insegnamento con questo strumento?',
    students: 'A quali studenti ti rivolgi?',
    'work-experience': 'Esperienza di lavoro',
    company: 'Nome azienda',
    role: 'Ruolo ricoperto',
    'start-year': 'Anno di inizio',
    'end-year': 'Anno di fine',
    still: 'Ancora in corso',
    description: 'Descrizione esperienza',
    'add-experience': 'Aggiungi esperienza',
    'save-exp': 'Salva',
    'sorry-work': 'Scusa! Non conosciamo la tua azienda, vuoi aggiungerla?',
    'add-company': 'Aggiungi',
    firstname: 'Nome',
    lastname: 'Cognome',
    address: 'Indirizzo',
    postcode: 'CAP',
    state: 'Provincia',
    country: 'Nazione',
    phone: 'Telefono',
    age: 'Età',
    email: 'Email',
    professionalTitle: 'Titolo professionale (sarà visibile sotto il tuo nome)',
    educationalTitle: 'Titolo di studio',
    success: 'Dati aggiornati con successo',
    bio: 'Bio',
    now: 'adesso',
  },
  classrooms: {
    classrooms: 'Classi',
  },
  media: {
    media: 'Media',
    title: 'I tuoi media',
    formats: 'I formati ammessi sono .pdf, .jpg, .png, .mov',
    size: 'Dimensione massima dei file: 6 MB',
    upload: 'Carica Media',
    delete: 'Se sicuro di voler eliminare il media ',
    cannotDelete: 'Non puoi eliminare questo media perché è legato a dei template.',
    available: 'Media disponibili',
    selected: 'Media selezionati',
  },
  template: {
    template: 'Template',
    templates: 'Templates',
    title: 'I tuoi templates',
    delete: 'Se sicuro di voler eliminare il template ',
    cannotDelete: 'Non puoi eliminare questo template perché è legato a dei tiers.',
    new: 'Nuovo',
    newTemplate: 'Nuovo template',
    description: 'Descrizione',
    save: 'Salva e aggiungi file multimediali',
  },
  tiers: {
    tier: 'Modello',
    tiers: 'Modelli di lezione',
    title: 'I tuoi modelli',
    book: 'Prenota una lezione con questo insegnante',
  },
  settings: {
    title: 'Deadline per le prenotazioni',
    deadline: 'Indica la deadline per le prenotazioni alle tue lezioni.',
    deleted: 'Gli slot non prenotati entro quel margine verranno automaticamente eliminati.',
    hours: 'ore',
    week: 'Una settimana',
    languages: 'Lingue',
    setLanguages: 'Indica le lingue in cui sei disponibile a fare lezione:',
    save: 'Salva',
    cancel: 'Deadline per la cancellazione',
    selectDeadline: 'Indica la deadline per la cancellazione gratuita delle tue lezioni.',
    payment: 'Le lezioni che non saranno cancellate entro quel margine verranno pagate dagli studenti anche se non si presentano a lezione.',
    other: 'Altro (in ore)',
  },
  tier: {
    edit: 'Modifica Tier',
    name: 'Nome Lezione',
    description: 'Descrizione della Lezione',
    price: "Prezzo all'ora",
    number: 'N. Lezioni',
    choose: 'Scegli',
    icon: 'icona',
    color: 'colore',
    add: 'Aggiungi',
    delete: 'Sei sicuro di voler eliminare il tier ',
    new: 'Nuovo modello di lezione',
    save: 'Salva',
  },
  upload: {
    upload: 'Carica',
    select: 'Seleziona un file',
    drag: 'Trascina il tuo file qui (solo ',
    or: 'oppure',
    notPdf: 'non è un pdf.',
    slideSuccess: 'Slide caricate con successo',
    selectImage: "Seleziona un'immagine",
    dragImage: 'Trascina la tua immagine',
    notImage: "non è un'immagine",
    imgSuccess: 'Immagine caricata con successo',
    notFormat: 'non è nel formato corretto.',
    chooseType: 'Scegli il tipo di file',
    image: 'Immagine',
    video: 'Video',
    pdf: 'Pdf',
    audio: 'Audio',
  },
  password: {
    accessData: 'Dati di accesso',
    changePassword: 'Cambia password',
    old: 'Vecchia password',
    new: 'Nuova password',
    newConfirm: 'Conferma nuova password',
    savePassword: 'Salva nuova password',
  },
  'fill-in': 'Compilare questo campo',
};
